module.exports = __webpack_public_path__ + "static/media/BreathingTechniques.86c2079b.mp3";